/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Cost_Tokens_OutputInputs */



/**
* | output |
* | --- |
* | "Output" |
*
* @param {Chat_Cost_Tokens_OutputInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_tokens_output = /** @type {((inputs?: Chat_Cost_Tokens_OutputInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Tokens_OutputInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabe")
	return /** @type {LocalizedString} */ ("Output")
});